export class NuevoClienteDTO {
    constructor(
        public nrRut: number,
        public dv: string,
        public nombre: string
    ) {
        this.nrRut = nrRut;
        this.dv = dv;
        this.nombre = nombre;
    }
}
